module.exports = __webpack_public_path__ + "img/114.2.f72de45e.png";